import React from 'react';
import { Button } from '@c2fo/liquidity';
import { PencilIcon } from '@c2fo/liquidity/icons';

interface EditButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

export const EditButton: React.FC<EditButtonProps> = ({ onClick, disabled = false, label = 'Edit' }) => {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      className="rounded-md bg-blue-500 text-white hover:text-black"
      size="sm"
      disabled={disabled}
    >
      <span className="flex items-center gap-1">
        <PencilIcon fill="white" />
        {label}
      </span>
    </Button>
  );
};
